import React, { FC, useEffect, useState } from 'react'
import styles from './GlobalHeader.module.scss'


interface GlobalHeaderProps {
  environment: string
  searchBar: boolean
  joinBtn: boolean
  isLoggedIn?: boolean
  isChannelOwner?: boolean
  isManager?: boolean
  loginRedirect?: string
  isPreAuthenticated?: boolean
  hostUrl?: string
  nonce?: string
}

const GlobalHeader: FC<GlobalHeaderProps> = ({ environment, searchBar = true, joinBtn = true, isLoggedIn, isChannelOwner, isManager, loginRedirect, isPreAuthenticated, hostUrl, nonce = '' }) => {

  const [pageLoaded, setPageLoaded] = useState(false)

  useEffect(() => {
    setPageLoaded(true)
  }, [])

  let baseUrl = hostUrl;
  if ( !hostUrl ){
	baseUrl = process.env.HOST
  }

  return (
    <div className={styles['global-header']}>
	  <link rel="modulepreload" href={baseUrl + `/webcomponent/dist/brighttalk-web-components/brighttalk-web-components.esm.js`}></link>
      {pageLoaded && <portal-header env={environment} search={searchBar} join={joinBtn} loggedin={isLoggedIn} manager={isManager} channelowner={isChannelOwner} loginRedirect={loginRedirect} preauth={isPreAuthenticated} />}
    </div>
  );
}

export default GlobalHeader
